// TODO: Move this to RSUI
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button } from '@redshelf/redshelf-ui';

import { Box, InputAdornment, makeStyles, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

// TODO: Figure out a cleaner way to set the height(s) of TextField (Input) and Button to be the same based on the 'size' prop of either
// or if 'size' is passed to the SelectField component itself in an effort to adjust the size of the SearchField component.
const useStyles = makeStyles((theme) => {
  return {
    textField: {
      width: 420,
      marginRight: theme.spacing(1),
    },
  };
});

const SearchField = ({
  onSearch,
  TextFieldProps,
  ButtonProps,
  size,
  ...props
}) => {
  const classes = useStyles();

  const [value, setValue] = useState('');

  const handleOnSearch = () => {
    if (!onSearch) {
      return;
    }
    onSearch(value);
  };

  const handleOnChange = (event) => {
    setValue(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.keyCode !== 13) {
      return;
    }
    handleOnSearch();
  };

  return (
    <Box display="flex" justifyContent="center" {...props}>
      <TextField
        value={value}
        className={classes.textField}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        onChange={handleOnChange}
        onKeyDown={handleKeyDown}
        variant="outlined"
        size={size}
        {...TextFieldProps}
      />
      <Button
        onClick={handleOnSearch}
        variant="primary"
        size={size}
        {...ButtonProps}
      >
        Search
      </Button>
    </Box>
  );
};

SearchField.propTypes = {
  /**
   * Callback fired when `Button` is clicked or on 'Enter' `onKeyDown` event if `TextField` is focused.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onSearch: PropTypes.func,
  /**
   * Props applied to the `TextField` element.
   */
  TextFieldProps: PropTypes.object,
  /**
   * Props applied to the `Button` element.
   */
  ButtonProps: PropTypes.object,
};

SearchField.defaultProps = {};

export default SearchField;
